import './mod/avif-webp'
import { Particle } from 'jparticles'
import './mod/contactForm7'
import './mod/partners_colab'

import signature from 'console-signature'
;(function ($) {
    ; ('use strict')


    /** Global vars defined by functions.php with 'wp_localize_script' @ script enqueue   **/
    var global = pct_globalVars

    signature()

    // window.addEventListener('load', function (event) {

   window.addEventListener('DOMContentLoaded', function (event) {
        // !STICKY MENU HEADER
        // Define observer for header menu

        if (document.querySelector('body.ast-primary-sticky-enabled')) {
            const elemToObserve = document.querySelector('#ast-desktop-header .ast-above-header')
            // const elemToObserve = document.querySelector('#ast-desktop-header .main-header-bar-wrap')
            const makeSticky = document.querySelector('#ast-desktop-header .main-header-bar')
            const body = document.querySelector('body')

            let observerOptions = {
                root: null,
                rootMargin: '0px',
                // threshold: [0.1],
            }

            const callback = (entries) => {
                entries.forEach((entry) => {
                    // console.log(entry.intersectionRatio)

                    if (!entry.isIntersecting) {
                        makeSticky.style.top = '0px'
                        makeSticky.style.position = 'fixed'
                        // body.classList.add('ast-primary-sticky-header-active')
                        // makeSticky.classList.add('ast-sticky-active', 'ast-sticky-shrunk', 'ast-header-sticked')
                    }
                    else {
                        makeSticky.style.position = 'relative'
                        // makeSticky.classList.remove('ast-sticky-active', 'ast-sticky-shrunk', 'ast-header-sticked')
                        // body.classList.remove('ast-primary-sticky-header-active')
                    }
                })
            }

            let headerObserver = new IntersectionObserver(callback, observerOptions)
            headerObserver.observe(elemToObserve)
       }


    })



    /**
     * Customize language switcher
     */


    const switcherContDom = document.querySelector(
        '.site-header-above-section-right #polylang-3, #ast-mobile-header #polylang-3'
    )
    const menuLangSwitcherDom = document.querySelectorAll(
        '.site-header-above-section-right #polylang-3 nav ul li a, #ast-mobile-header #polylang-3 nav ul li a'
    )

    menuLangSwitcherDom.forEach((el) => {
        el.text = el.text.substring(0, 2)
    })

    switcherContDom.classList.add('enabled')

    /**
     *  AVIF BACKGROUND IMAGES BY CLASS SELECTOR
     *  if not AVIF capabilities, then use a .jpg instead
     * AVIF capabilities checked by avif-webp.js, adding a webp/avif class to <html> tag.
     */
    ;[].slice.call(document.querySelectorAll('[class*="pct-avif-bg-"]')).forEach(function (el) {
        var $el = $(el)
        var fileName = $el
            .attr('class')
            .match(/pct-avif-bg-(.*)+/)[0]
            .split(' ')[0]
            .split('pct-avif-bg-')[1]
        var filePath = global.mediaURL + '/' + fileName + '.' + ($('html').hasClass('avif') ? 'avif' : 'jpg')

        $el.prepend('<div class="pct-bgimg"></div>')
        var $bg = $el.find('.pct-bgimg')
        $bg.css({
            'background-image': 'url(' + filePath + ')',
            'background-size': 'cover',
            'position': 'absolute',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
        })
    })

    /*------------------------------------------------------------------------------------------------------*
              ASTRA THEME SPECIFIC FIXES (Mobile: Main and Sticky header won't collapse on scroll or after scroll)
  \*------------------------------------------------------------------------------------------------------*/
    /**
     * Fixing MegaMenu on resize window
     */
    var resizeW

    window.onresize = () => {
        clearTimeout(resizeW)
        resizeW = setTimeout(resizeUpdates, 500)
    }

    const resizeUpdates = () => {
        /** Check if body.ast-desktop exists => MengaMenu enabled | Mobile menu hided */
        const desktopMenu = document.querySelector('body.ast-desktop')
        const mm = document.querySelectorAll('.astra-full-megamenu-wrapper')

        mm.forEach((el) => {
            //get parent li position
            el.classList.add('full-width')
            const submenu = el.querySelector('.sub-menu')

            const menuItem = el.parentNode.getBoundingClientRect()
            const left = menuItem.left + document.body.scrollLeft

            // console.log(left,el)

            el.style.left = `${-left}px` // 922-936 fials
            // el.style.transform = `translateX(${-left}px)`
            el.style.visibility = 'visible'
        })

        if (desktopMenu) {
            const body = document.querySelector('body')
            const bodyNavOpened = body.classList.contains('ast-main-header-nav-open')

            if (bodyNavOpened) {
                body.classList.remove('ast-main-header-nav-open')
                const buttonToggle = document.querySelector('#ast-mobile-header button.menu-toggle')

                if (buttonToggle)
                    document.querySelector('#ast-mobile-header button.menu-toggle').classList.remove('toggled')
            }
        }

        if (!desktopMenu) {
            const tree = {
                mainMenu: document.querySelector('.ast-builder-menu-mobile'),
            }


            tree['nav'] = tree['mainMenu'].querySelector('#ast-mobile-site-navigation')


            if (tree['nav'].querySelectorAll('.astra-megamenu-li').length) {

                tree['nodes'] = tree['nav'].querySelectorAll('.astra-megamenu-li')
                tree['nodes'].forEach((el) => {
                    // el.addEventListener('touchstart', toggleMegaMenu(this))
                    const megaMenu = el.querySelector('.astra-full-megamenu-wrapper > ul')
                    const expanded = el.classList.contains('ast-submenu-expanded')
                    const showingMM = megaMenu.style.display === 'block'

                    el.addEventListener('click', (e) => {
                        const mm = el.querySelector('.astra-full-megamenu-wrapper > ul')
                        tree['current_node'] = el
                        tree['ul'] = mm
                        toggleMM(tree)
                    })
                })
            }


            function toggleMM(fullTree) {
                const toggled = fullTree.current_node.classList.contains('ast-submenu-expanded')
                fullTree.ul.style.display = toggled ? 'block' : 'none'
                fullTree.ul.parentNode.classList.remove('ast-hidden')
                fullTree.ul.classList.remove('ast-hidden')
            }
        }
    }
    resizeUpdates();



    // Remove click to # for hrefs = # on main menu
    document.querySelectorAll('.menu-link[href="#"]').forEach((el) => {
        // el.setAttribute('href', 'javascript:void(null)')
        // el.addEventListener('click', (e) => {
        //     e.preventDefault()
        // })
    })

    // Remove click for megamenu parent menu nodes
    document.querySelectorAll('.menu-item-has-children .menu-link').forEach((el) => {
        // el.setAttribute('href', 'javascript:void(null)')
        // el.addEventListener('click', (e) => {
        //     e.preventDefault()
        // })
    })

    document
        .querySelector('button.menu-toggle.main-header-menu-toggle.ast-mobile-menu-trigger-minimal')
        .addEventListener('click', (e) => {
            const htmlDom = document.querySelector('html,body')
            if (!document.querySelector('body.ast-header-break-point.ast-main-header-nav-open')) {
                // console.log('abrimos menú')
                htmlDom.style.overflowY = 'hidden'
            } else {
                // console.log('cerramos menú')
                htmlDom.style.overflowY = 'auto'
            }
        })

    /**
     * ! Modify page header duplicating background image as element for design effects
     */
    const header = document.querySelector('body.ast-advanced-headers .ast-title-bar-wrap') || null

    if (header) {
        const style = header.currentStyle || window.getComputedStyle(header, false)
        // const headerBgImageURL = style.backgroundImage.slice(4, -1).replace(/"/g, '')
        let headerBgImageURL = style.backgroundImage.slice(4, -1).replace(/"/g, '')

        let bgImgUrlArr = style.backgroundImage.slice(4, -1).replace(/"/g, '').split('//')[1].split('/')

        const baseURL = bgImgUrlArr.slice(
            0,
            bgImgUrlArr.findIndex((string) => string === 'xen_media')
        )

        // console.log('hostname= ' + window.location.hostname + ' type= ' + typeof window.location.hostname)

        // console.log('baseURL= ' + baseURL)

        // console.log('BEFORE media folder = : ' + bgImgUrlArr)

        bgImgUrlArr = bgImgUrlArr.slice(-2)

        // console.log('AFTER media folder: ' + bgImgUrlArr)

        headerBgImageURL = '//' + baseURL.join('/') + '/' + bgImgUrlArr.join('/')

        // console.log('final url= ' + headerBgImageURL)

        header.classList.add('no-background')

        const bgImage = document.createElement('img')
        bgImage.setAttribute('src', headerBgImageURL)
        bgImage.setAttribute('class', 'header-bgImage')
        header.appendChild(bgImage)

        const overlay = document.createElement('img')
        overlay.setAttribute('src', headerBgImageURL)
        overlay.setAttribute('class', 'header-overlay')
        header.appendChild(overlay)

        header.classList.add('shown')
    }

    /*------------------------------------------------------------------------------------------------------*
                            footer particles
    \*------------------------------------------------------------------------------------------------------*/
    // const p = new Particle('#footer-bg-canvas', {
    //     color: '#565656',
    //     // color: '#464646',
    //     // color: '#ffffff',
    //     num: 0.1,
    //     maxSpeed: 0.2,
    //     proximity: 50,
    //     range: 2000,
    //     // parallax: true,
    //     lineShape: 'cube',
    // })

})(jQuery)
